module.exports = __webpack_public_path__ + "static/media/jj-help2.40e303cf.png";